import "./countdown.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Countdown = ({ onComplete, height }) => {
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const intervals = [0, 1500, 3000, 4500];
    const timers = intervals.map((delay, i) =>
      setTimeout(() => setActiveIndex(i + 1), delay)
    );

    const completeTimer = setTimeout(() => {
      onComplete();
    }, 6000);

    return () => {
      timers.forEach(clearTimeout);
      clearTimeout(completeTimer);
    };
  }, []);

  const items = ["3", "2", "1", "Play"];

  return (
    <div
      className={`container-countdown ${isDarkMode ? "container-countdown-dark" : ""}`}
      style={{ height: height }}
    >
      <div className="countdown-center">
        {/* Spinning circular arc */}
        <svg className="spinner-ring" viewBox="0 0 200 200">
          <defs>
            <linearGradient
              id="arcGradient"
              gradientUnits="userSpaceOnUse"
              x1="100"
              y1="10"
              x2="10"
              y2="190"
            >
              <stop
                offset="0%"
                stopColor={isDarkMode ? "#ffffff" : "#684199"}
                stopOpacity="1"
              />
              <stop
                offset="100%"
                stopColor={isDarkMode ? "#ffffff" : "#684199"}
                stopOpacity="0"
              />
            </linearGradient>
          </defs>
          <circle
            cx="100"
            cy="100"
            r="90"
            fill="none"
            stroke="url(#arcGradient)"
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray="400 166"
          />
        </svg>

        {/* Numbers in the center */}
        {items.map((item, i) => (
          <span
            key={i}
            className={`spanText ${isDarkMode ? "spanText-dark" : ""} ${
              activeIndex === i + 1 ? "active" : ""
            } ${activeIndex > i + 1 ? "done" : ""} ${
              item === "Play" ? "spanText-play" : ""
            }`}
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
